import HotelIcon from '@mui/icons-material/Hotel';
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from "@mui/lab";
import { Dialog, DialogContent, DialogTitle, Grid2, IconButton, Paper, Typography } from "@mui/material";
import { FC } from "react";
import { FaUser, FaUserAltSlash } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../Form/Button/button.scomponent";
import { ButtonActionMenu } from "../../../Form/ButtonActionsMenu/button-action-menu.component";
import { Placeholder } from "../../../Placeholder/placeholder.component";
import { SaleProductTable } from "../../../Table/variants/sale-product-table/sale-product-table.component";
import { ISaleEntity } from '../../../../Pages/Financial/Details/financial-details.hook';

export interface IOrderData {
  id: string;
  nsOrderId: string;
  customer?: {
    id: string;
    name: string;
    email: string;
    phone: string;
  };
  seller?: {
    id: string;
    name: string;
  };
  sellerAlreadyAdded: boolean;
  observations?: string;
}

interface IOrderDetailsModalProps {
  open: boolean;
  onClose: () => void;
  sale?: ISaleEntity;
  orderData?: IOrderData;
  onSelectSeller?: () => void;
  onOrderWithoutSeller?: () => void;
}

const OrderDetailsModal: FC<IOrderDetailsModalProps> = ({
  open,
  onClose,
  sale,
  orderData,
  onSelectSeller,
  onOrderWithoutSeller
}) => {
  const navigate = useNavigate();
  
  console.log('OrderDetailsModal - sale data:', sale);
  console.log('OrderDetailsModal - orderData:', orderData);

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          minHeight: '80vh',
          maxHeight: '90vh'
        }
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        borderBottom: '1px solid #e0e0e0'
      }}>
        <Typography variant="h5" fontWeight={600}>
          Detalhes - Pedido {orderData?.nsOrderId}
        </Typography>
        <IconButton onClick={onClose} size="small">
          <MdClose size={24} />
        </IconButton>
      </DialogTitle>
      
      <DialogContent sx={{ padding: '24px' }}>
        <Grid2 container spacing={4}>
          <Grid2 size={8} sx={{ borderBottom: 'solid 1px dashed' }}>
            {sale?.id ? (
              <SaleProductTable sale={sale} />
            ) : (
              <Placeholder description="Erro ao carregar pedido." />
            )}
          </Grid2>

          <Grid2 size={4}>
            <Paper sx={{ padding: '20px' }}>
              <Typography sx={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '15px' }}>
                Dados do cliente
              </Typography>

              <Typography sx={{ fontSize: '1rem', fontWeight: 500, marginBottom: '5px' }}>
                <b>Nome: </b>{sale?.customer?.name || 'Não informado'}
              </Typography>

              <Typography sx={{ fontSize: '1rem', fontWeight: 500, marginBottom: '5px' }}>
                <b>E-mail: </b>{sale?.customer?.email || 'Não informado'}
              </Typography>

              <Typography sx={{ fontSize: '1rem', fontWeight: 500, marginBottom: '5px' }}>
                <b>Fone: </b>{sale?.customer?.phone || 'Não informado'}
              </Typography>

              {sale?.customer?.personType === "PJ" && (
                <Typography sx={{ fontSize: '1rem', fontWeight: 500, marginBottom: '5px' }}>
                  <b>Inscrição Estadual: </b>{sale?.customer?.stateRegistration || 'Não informado'}
                </Typography>
              )}

              <Button 
                sx={{ marginTop: '20px' }} 
                onClick={() => navigate(`/customers-form/${orderData?.customer?.id}`)}
              >
                Editar dados
              </Button>
            </Paper>

            <Paper sx={{ padding: '20px', marginTop: '30px' }}>
              <Typography sx={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '15px' }}>
                Endereço de entrega
              </Typography>
              
              <Typography sx={{ fontSize: '1rem', fontWeight: 500, marginBottom: '5px' }}>
                {sale?.shippingAddress?.id 
                  ? `${sale?.shippingAddress?.name} ${sale?.shippingAddress?.number}, ${sale?.shippingAddress?.locality} - ${sale?.shippingAddress?.city} - ${sale?.shippingAddress?.province} | ${sale?.shippingAddress?.zipcode}` 
                  : 'Não informado.'
                }
              </Typography>
            </Paper>

            <Paper sx={{ padding: '20px', marginTop: '30px' }}>
              <Typography sx={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '15px' }}>
                Endereço de cobrança
              </Typography>
              
              <Typography sx={{ fontSize: '1rem', fontWeight: 500, marginBottom: '5px' }}>
                {sale?.billingAddress?.id 
                  ? `${sale?.billingAddress?.name} ${sale?.billingAddress?.number}, ${sale?.billingAddress?.locality} - ${sale?.billingAddress?.city} - ${sale?.billingAddress?.province} | ${sale?.billingAddress?.zipcode}` 
                  : 'Não informado.'
                }
              </Typography>
            </Paper>

            {orderData?.observations && (
              <Paper sx={{ padding: '20px', marginTop: '30px' }}>
                <Typography sx={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '15px' }}>
                  Observações
                </Typography>
                
                <Typography sx={{ fontSize: '1rem', fontWeight: 500, marginBottom: '5px', fontStyle: 'italic', color: 'text.secondary' }}>
                  {orderData.observations}
                </Typography>
              </Paper>
            )}

            <Paper sx={{ padding: '20px', marginTop: '30px' }}>
              <Typography sx={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '15px' }}>
                Dados do Vendedor
              </Typography>

              {orderData?.sellerAlreadyAdded ? (
                <Typography sx={{ fontSize: '1rem', fontWeight: 500, marginBottom: '5px' }}>
                  {orderData?.seller?.name || 'Pedido Sem Vendedor'}
                </Typography>
              ) : (
                <Typography sx={{ fontSize: '1rem', fontWeight: 500, marginBottom: '5px' }}>
                  Nenhum vendedor informado
                </Typography>
              )}

              <ButtonActionMenu 
                customMenu={
                  <Button sx={{ width: '250px', marginTop: '20px' }}>
                    Atribuir Vendedor
                  </Button>
                } 
                options={[
                  {
                    title: 'Atribuir Vendedor',
                    onClick: onSelectSeller || (() => {}),
                    icon: <FaUser />
                  },
                  {
                    title: 'Pedido SEM Vendedor',
                    onClick: onOrderWithoutSeller || (() => {}),
                    icon: <FaUserAltSlash />
                  }
                ]} 
              />
            </Paper>

            <Paper sx={{ padding: '20px', marginTop: '30px' }}>
              <Typography sx={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '15px' }}>
                Histórico
              </Typography>
              
              <Timeline position="right">
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineConnector />
                    <TimelineDot color="primary" variant="outlined">
                      <HotelIcon />
                    </TimelineDot>
                    <TimelineConnector sx={{ bgcolor: 'secondary.main' }} />
                  </TimelineSeparator>
                  <TimelineContent sx={{ py: '12px' }}>
                    <Typography variant="h6" component="span">
                      Venda Registrada
                    </Typography>
                    <Typography>Por iehwefdr@guerrillamailblock.com de Pedidos manuais</Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineConnector />
                    <TimelineDot color="primary" variant="outlined">
                      <HotelIcon />
                    </TimelineDot>
                    <TimelineConnector sx={{ bgcolor: 'secondary.main' }} />
                  </TimelineSeparator>
                  <TimelineContent sx={{ py: '12px', px: 2 }}>
                    <Typography variant="h6" component="span">
                      Venda Registrada
                    </Typography>
                    <Typography>Por iehwefdr@guerrillamailblock.com de Pedidos manuais</Typography>
                  </TimelineContent>
                </TimelineItem>
              </Timeline>
            </Paper>
          </Grid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
};

export { OrderDetailsModal };
